import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Background from "gatsby-background-image"
import styled from "styled-components"

const StyledSection = styled(Background)`
  padding: 106px 16px 0;
  min-height: 360px;
  & h1 {
    font-size: 36px;
    line-height: 48px;
    letter-spacing: 0.5px;
    color: #fff;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.75);
    width: 50%;
    font-family: "Made Evo Medium", sans-serif;
    @media (min-width: 768px) {
      width: 70%;
    }
    @media (min-width: 1024px) {
      font-size: 48px;
      max-width: 990px;
    }
  }
  & p {
    font-size: 18px;
    line-height: 29px;
    letter-spacing: 0.3px;
    color: #fff;
    margin-top: 10px;
    width: 60%;
    @media (min-width: 768px) {
      width: 70%;
    }
    @media (min-width: 1024px) {
      font-size: 20px;
      margin-top: 30px;
    }
  }
  @media (min-width: 768px) {
    & div {
      max-width: 576px;
      margin: 0 auto;
    }
  }
  @media (min-width: 1024px) {
    padding: 312px 16px 0;
    min-height: 850px;
    & div {
      max-width: 900px;
    }
  }
  @media (min-width: 1200px) {
    & div {
      max-width: 1200px;
    }
  }
`

const Header = () => {
  const { aboutUsBg } = useStaticQuery(graphql`
    query {
      aboutUsBg: file(relativePath: { eq: "o-nas-bg.png" }) {
        childImageSharp {
          fluid(maxWidth: 2880) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)
  return (
    <StyledSection Tag="section" fluid={aboutUsBg.childImageSharp.fluid}>
      <div>
        <h1>Ludzie, Technologia & Pomysły</h1>
        <p>
          Trochę o nas, w końcu nie jesteśmy robotami{" "}
          <span role="img" aria-label="emoji">
            😉
          </span>
        </p>
      </div>
    </StyledSection>
  )
}

export default Header
